import { VideoIcon, MicIcon, MessageSquareIcon } from './icons';
import type { CommunicationMode } from '../types/app';

interface ModeSwitcherProps {
  currentMode: CommunicationMode;
  onModeChange: (mode: CommunicationMode) => void;
  /** When true, renders a small notification dot on the Chat tab. */
  chatHasUnread?: boolean;
}

export function ModeSwitcher({
  currentMode,
  onModeChange,
  chatHasUnread = false,
}: ModeSwitcherProps) {
  return (
    <div className="flex gap-1 bg-brand-navy p-1.5 rounded-sm">
      {([
        { id: 'video' as const, icon: <VideoIcon size={16} />, label: 'Video' },
        { id: 'audio' as const, icon: <MicIcon size={16} />, label: 'Audio' },
        { id: 'chat' as const, icon: <MessageSquareIcon size={16} />, label: 'Chat' },
      ]).map((mode) => {
        const showUnreadDot = mode.id === 'chat' && chatHasUnread && currentMode !== 'chat';
        return (
          <button
            key={mode.id}
            onClick={() => onModeChange(mode.id)}
            className={`relative px-5 py-2.5 text-xs tracking-[0.15em] uppercase transition-all duration-500 font-sans flex items-center gap-2 ${
              currentMode === mode.id
                ? 'bg-brand-gold text-white'
                : 'text-white/60 hover:text-white'
            }`}
            aria-label={mode.label}
            aria-pressed={currentMode === mode.id}
          >
            {mode.icon}
            {mode.label}
            {showUnreadDot && (
              <span
                aria-label="New messages"
                data-testid="chat-unread-indicator"
                className="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-brand-gold"
              />
            )}
          </button>
        );
      })}
    </div>
  );
}
